export default __webpack_public_path__ + "static/media/github-icon.15e3f216.svg";